import { Grid } from "@material-ui/core";
import {
  InputTextMaster,
  MasterButton,
  Modal,
  InputOptionMaster,
} from "App/Component/ui";
import {
  DEFAULT_SHOW_BUTTON_SUBMIT,
  DISABLED_BUTTON_SUBMIT,
  instance2,
  TYPE_INSTANCE1,
} from "App/constants";
import { useSelectOption } from "App/hooks";
import {
  defaultToastError,
  defaultToastSuccess,
  isNull,
} from "App/utils/helpers";
import React, { useContext } from "react";
import { FormContext } from "../context/FormContext";
import { urlCreateDetailPaket, urlUpdateDetailPaket } from "../helpers";
export default function ModalPaket({ setNewDataPaketList }) {
  const dokter = useSelectOption(
    true,
    "/doctor/listdoctor_regrj",
    TYPE_INSTANCE1,
    "id",
    "fullname"
  );

  const {
    disabled,
    setDisabled,
    formData,
    setShowModaPaket,
    formDetail,
    setFormDetail,
  } = useContext(FormContext);

  const create = async () => {
    const api = await instance2.post(urlCreateDetailPaket, {
      paket_tarif_tele_header_id: formData.id,
      id_dokter: formDetail.id_dokter,
      dokter: formDetail.dokter,
      remark: formDetail.remark,
    });
    return api;
  };

  const update = async () => {
    const api = await instance2.post(urlUpdateDetailPaket, {
      paket_tarif_tele_header_id: formData.id,
      id_dokter: formDetail.id_dokter,
      dokter: formDetail.dokter,
      remark: formDetail.remark,
      id: formDetail.id,
    });
    return api;
  };

  const handleChange = (text) => (e) => {
    setFormDetail({
      ...formDetail,
      [text]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisabled(DISABLED_BUTTON_SUBMIT);
    if (
      isNull(formDetail.id_dokter)
      // || isNull(formDetail.golongan_id)
    ) {
      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
      defaultToastError("Harap pilih dokter terlebih dahulu!");
    } else {
      try {
        if (isNull(formDetail.id)) {
          const res = await create();
          if (res.data.status === 201) {
            defaultToastSuccess("Berhasil menambah data");
            setNewDataPaketList(formData.id);
            setShowModaPaket(false);
            setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
          } else {
            setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
            defaultToastError(res.data.message);
          }
        } else {
          const res = await update();
          if (res.data.status === 200) {
            defaultToastSuccess("Berhasil memperbarui data");
            setNewDataPaketList(formData.id);
            setShowModaPaket(false);
            setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
          } else {
            setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
            defaultToastError(res.data.message);
          }
        }
      } catch (error) {
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
        defaultToastError(error?.response?.data?.message);
      }
    }
  };

  console.log('ModalPaket', formDetail)

  return (
    <Modal
      title={formDetail.onCreate ? "Tambah Paket" : "Ubah Paket"}
      show={setShowModaPaket}
      width="80%"
    >
      <form action="POST" onSubmit={(e) => handleSubmit(e)}>
        <Grid container spacing={1}>
          <InputTextMaster
            type="hidden"
            name="barang_id"
            id="barang_id"
            readOnly={true}
            value={formDetail?.id}
          />
          <Grid item sm={12}>
            <InputOptionMaster
              name="doctor"
              label="DOKTER"
              id="doctor"
              withSearch={true}
              data={dokter}
              labelValue={formDetail.dokter}
              value={formDetail.id_dokter}
              onChange={(e) => {
                if (isNull(e)) {
                  setFormDetail({
                    ...formDetail,
                    id_dokter: null,
                    dokter: "Pilih Dokter",
                  });
                } else {
                  setFormDetail({
                    ...formDetail,
                    id_dokter: e.value,
                    dokter: e.label,
                  });
                }
              }}
            />
          </Grid>

          <Grid item sm={12}>
            <InputTextMaster
              name="remarkPaket"
              label="Catatan"
              id="remarkBarang"
              value={formDetail?.remark}
              onChange={handleChange("remark")}
              placeholder="Catatan"
            />
          </Grid>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="flex-end"
          alignItems="center"
        >
          <MasterButton
            className={"mt-1"}
            type="submit"
            color={disabled.color}
            name={disabled.label}
            disabled={disabled.disabled}
            size="md"
          />
        </Grid>
      </form>
    </Modal>
  );
}
